module.exports = __webpack_public_path__ + "static/white-tassel-13edda0d1a42b0b7769c88cc452814db.png";